import { render, staticRenderFns } from "./GestionObjetivos.vue?vue&type=template&id=6386e979&"
import script from "./GestionObjetivos.vue?vue&type=script&lang=js&"
export * from "./GestionObjetivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports